import * as firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/storage'

import {
    BRAND_CREATE,
    BRAND_FETCH,
    BRAND_UPDATE,
    BRAND_FETCH_PROMO,
    BRAND_UPDATE_PROMO
} from './types';

// export const brandUpdatePromo = (data, oldImg) => {
//     return (dispatch) => {
//         dispatch({ type: BRAND_UPDATE_PROMO, payload: true })
//         if(data.photo) {
//             const filename = Date.now()+"."+data.photo.name.split('.').pop()
//             // Upload File to firebase storage
//             const storage = firebase.storage().ref()
//             const fileRef = storage.child('brand/'+filename)
//             fileRef.put(data.photo).then(()=>{
//                 fileRef.getDownloadURL().then((url) => {
//                     firebase.database().ref('brands/').update({ brand_promo: url })
//                     .then(() => {
//                         firebase.database().ref('brands/').update({ brand_url: data.url })
//                         .then(()=>removeOldFile(oldImg))
//                     })
//                 })
//             })
//         } else {
//             firebase.database().ref('brands/').update({ brand_url: data.url })
//             .then(()=>window.location = '/admin/product')
//         }
//     }
// }
export const brandUpdatePromo = (data) => {
    return (dispatch) => {
        dispatch({ type: BRAND_UPDATE_PROMO, payload: true })
        for (const [key, item] of Object.entries(data)) {
            if (JSON.stringify(item) !== '{}') {
                const filename = Date.now()+"."+item.file.name.split('.').pop()
                // Upload File to firebase storage
                const storage = firebase.storage().ref()
                const fileRef = storage.child('brand_promotion/'+filename)
                fileRef.put(item.file).then(()=>{
                    fileRef.getDownloadURL().then((url) => {
                        firebase.database().ref(`brand_promotions/${key}/`).update({ url })
                        .then(() => {
                            removeOldFile(item.oldImg)
                        })
                    })
                })

            }
        }
    }
}

// export const brandFetchPromo = () => {
//     return (dispatch) => {
//         let data = []
//         const brandsRef = firebase.database().ref('brands/brand_promo')
// 		brandsRef.once('value', function(snapshot) {
//             data.push(snapshot.val())
//             const brandsRef2 = firebase.database().ref('brands/brand_url')
// 		    brandsRef2.once('value', function(snapshot) {
//                 data.push(snapshot.val())
//                 dispatch({ type: BRAND_FETCH_PROMO, payload: data })
//             })
// 		})
//     }
// }
export const brandFetchPromo = () => {
    return (dispatch) => {
        let data = []
        const brandsRef = firebase.database().ref('brand_promotions')
        brandsRef.once('value', function(snapshot) {
            snapshot.forEach(childSnapshot => {
                data.push(childSnapshot.val())
            })
            dispatch({ type: BRAND_FETCH_PROMO, payload: data })
        })
    }
}

export const brandDeleteById = (id, oldImg) => {
    return (dispatch) => {
        firebase.database().ref('brands/'+id).remove()
        .then(() => {
            // ===Reorder Brand===
            firebase.database().ref('brands').once('value', snapshot => {
                let data2 = []
                snapshot.forEach(childSnapshot => {
                    data2.push(childSnapshot.val())
                })
                data2.sort((a,b) => (Number(a.order) > Number(b.order)) ? 1 : ((Number(b.order) > Number(a.order)) ? -1 : 0))
                let run = 1
                data2.forEach((item) => {
                    if(typeof item === 'object') {
                        firebase.database().ref('brands/'+item.id).update({ order: run })
                        run++
                    }
                });
                setTimeout(()=>removeOldFile(oldImg), 1000)
            })
            // ===Reorder Brand===
        })
    }
}

const removeOldFile = (src) => {
    var ref = firebase.storage().ref().child(src);
    // Delete the file
    ref.delete().then(() => {
        window.location = "/admin/product"
    }).catch((error) => {
        window.location = "/admin/product"
    });
}

const brandCheckOrder = (id, order, oldOrder) => {
    return new Promise(resolve => {
        firebase.database().ref('brands').once('value', snapshot => {
            let data = []
            snapshot.forEach(childSnapshot => {
                let item = childSnapshot.val()
                if( typeof item === 'object') {
                    item.order = Number(item.order)
                    data.push(item)
                }
            })
            data.sort((a,b) => (a.order > b.order) ? 1 : ((b.order > a.order) ? -1 : 0))
            oldOrder = Number(oldOrder)
            order = Number(order)
            if(oldOrder > order) {
                let run = Number(order)+1
                data.forEach((item) => {
                    if(item.order < oldOrder && item.order >= order && item.id !== id) {
                        firebase.database().ref('brands/'+item.id).update({ order: run })
                        run++
                    }
                });
                setTimeout(()=>resolve(true), 1000)
            } else if (oldOrder < order) {
                let run = Number(oldOrder)
                data.forEach((item) => {
                    if(item.order > oldOrder && item.order <= order && item.id !== id) {
                        firebase.database().ref('brands/'+item.id).update({ order: run })
                        run++
                    }
                });
                setTimeout(()=>resolve(true), 1000)
            }
        })
    })
}

export const brandUpdateById = (id, data, oldImg, oldOrder) => {
    return (dispatch) => {
        dispatch({ type: BRAND_UPDATE, payload: true })
        if(data.img){
            const filename = Date.now()+"."+data.img.name.split('.').pop()
            // Upload File to firebase storage
            const storage = firebase.storage().ref()
            const fileRef = storage.child('brand/'+filename)
            fileRef.put(data.img).then(()=>{
                fileRef.getDownloadURL().then((url) => {
                    data.img = url
                    firebase.database().ref('brands/'+id).update(data)
                    .then(async res => {
                        const chk = await brandCheckOrder(id, data.order, oldOrder)
                        if (chk) {
                            removeOldFile(oldImg)
                        }
                    })
                    .catch(err => {
                        dispatch({ type: BRAND_UPDATE, payload: false })
                    })
                }).catch((err) => {
                    dispatch({ type: BRAND_UPDATE, payload: false })
                })
            })
        } else {
            delete data.img
            firebase.database().ref('brands/'+id).update(data)
            .then(async res => {
                const chk = await brandCheckOrder(id, data.order, oldOrder)
                if (chk) {
                    window.location = "/admin/product"
                }
            })
            .catch(err => dispatch({ type: BRAND_UPDATE, payload: false }))
        }
    }
}

export const brandFetch = () => {
    return (dispatch) => {
        let	brandsRef = firebase.database().ref('brands')
		brandsRef.once('value', snapshot => {
			let data = []
			snapshot.forEach(childSnapshot => {
                let item = childSnapshot.val()
                if( typeof item === 'object') {
                    item.order = Number(item.order)
                    data.push(item)
                }
            })
            data.sort((a,b) => (a.order > b.order) ? 1 : ((b.order > a.order) ? -1 : 0))
			dispatch({ type: BRAND_FETCH, payload: data });
		})
    }
}

export const brandCreate = (data) => {
    return (dispatch) => {
        dispatch({ type: BRAND_CREATE, payload: true })
        const filename = Date.now()+"."+data.img.name.split('.').pop()
        const storage = firebase.storage().ref()
        const fileRef = storage.child('brand/'+filename)
        fileRef.put(data.img).then(()=>{
            fileRef.getDownloadURL().then((url) => {
                const brandsRef = firebase.database().ref('brands').push()
                const id = brandsRef.key
                data.id = id
                data.img = url
                brandsRef.set(data)
                .then(response => {
                    // ===Reorder Brand===
                    firebase.database().ref('brands').once('value', snapshot => {
                        let data2 = []
                        snapshot.forEach(childSnapshot => {
                            data2.push(childSnapshot.val())
                        })
                        data2.sort((a,b) => (Number(a.order) > Number(b.order)) ? 1 : ((Number(b.order) > Number(a.order)) ? -1 : 0))
                        data2.splice(data2.findIndex(e => e.id === data.id),1);
                        let run = 2
                        data2.forEach((item) => {
                            if(typeof item === 'object') {
                                firebase.database().ref('brands/'+item.id).update({ order: run })
                                run++
                            }
                        });
                        setTimeout(()=>window.location = "/admin/product", 1000)
                    })
                    // ===Reorder Brand===
                })
                .catch(err => {
                    console.log("brandCreate", err)
                })
            }).catch((error) => {
                dispatch({ type: BRAND_CREATE, payload: false })
                console.log('Fail to create brand', error)
            })
        })
    }
}